import React, { FC } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object, string, ref } from 'yup';
import { Form, LowercaseHeadline } from './NewPasswordForm.styles';
import Input from '../../../Input/Input';
import ResetPassword from '../../ResetPassword';
import { Headline, HeadlineBold } from '../../ResetPassword.styles';

interface INewPasswordForm {
  changePassword: (password: string) => void;
  apiError?: {
    title: string | null;
    description: string | null;
  };
}

const NewPasswordForm: FC<INewPasswordForm> = ({ changePassword, apiError }) => {
  const { t } = useTranslation();

  const newPasswordSchema = object({
    password: string().required(t('login.newPassword.passwordIsRequired')),
    passwordConfirmed: string()
      .required(t('login.newPassword.passwordConfirmationIsRequired'))
      .oneOf([ref('password'), null], t('login.newPassword.passwordsDoesNotMatch')),
  });

  const formMethods = useForm({
    defaultValues: {
      password: '',
      passwordConfirmed: '',
    },
    resolver: yupResolver(newPasswordSchema),
  });

  const { handleSubmit } = formMethods;
  const headline = (
    <Headline data-testid="new-password-form-headline">
      <HeadlineBold>{t('login.newPassword.enter')}&nbsp;</HeadlineBold>
      <LowercaseHeadline>{t('login.newPassword.newPassword')}</LowercaseHeadline>
    </Headline>
  );
  const resetPasswordForm = (
    <FormProvider {...formMethods}>
      <Form data-testid="new-password-form">
        <Input
          label={t('login.newPassword.newPassword')}
          registerPath={'password'}
          placeholder={t('login.newPassword.yourNewPassword')}
          type="password"
        />
        <Input
          label={t('login.newPassword.confirmPassword')}
          registerPath={'passwordConfirmed'}
          placeholder={t('login.newPassword.yourNewPassword')}
          type="password"
        />
      </Form>
    </FormProvider>
  );

  return (
    <ResetPassword
      headline={headline}
      content={resetPasswordForm}
      submit={handleSubmit(data => changePassword(data.password))}
      buttonText={t('login.newPassword.login')}
      apiError={apiError}
    />
  );
};

export default NewPasswordForm;
